/** @jsx jsx */
import { jsx } from '@emotion/core'
import React from 'react'
import { Modal } from 'antd-mobile'
import { observer } from 'mobx-react'
import { isMobile } from 'react-device-detect'
import useRootStore from '@store/useRootStore'
// css
import { ModalBg } from '@styles/base.style'
import { Button, CloseBtn } from '@styles/button.style'
import { UrgencyMessageWrap } from './index.style'

const UrgencyMessagePopup: React.FC = () => {
  const { globalStore, componentStore } = useRootStore()
  const { visibleUrgencyMessagePopup } = globalStore
  const { urgencyMessage = { title: '', content: '' } } = componentStore

  const onCloseClick = () => {
    globalStore.setVisibleUrgencyMessagePopup(false)
  }

  return (
    <Modal
      transparent
      maskClosable={false}
      visible={visibleUrgencyMessagePopup}
      onClose={onCloseClick}
      wrapClassName="urgency-message-popup"
      className="event"
    >
      <UrgencyMessageWrap className={!isMobile && 'pc-urgency-message-wrap'}>
        <div className="emergency-bg top">
          <span className="emergency-bar yellow"/>
          <span className="emergency-bar black"/>
          <span className="emergency-bar yellow"/>
          <span className="emergency-bar black"/>
          <span className="emergency-bar yellow"/>
          <span className="emergency-bar black"/>
          <span className="emergency-bar yellow"/>
          <span className="emergency-bar black"/>
          <span className="emergency-bar yellow"/>
          <span className="emergency-bar black"/>
          <span className="emergency-bar yellow"/>
          <span className="emergency-bar black"/>
          <span className="emergency-bar yellow"/>
          <span className="emergency-bar black"/>
          <span className="emergency-bar yellow"/>
          <span className="emergency-bar black"/>
          <span className="emergency-bar yellow"/>
        </div>
        <div className="notice-contents">
          <Button onClick={onCloseClick} className="close-btn" css={CloseBtn}>
            <span className="close-txt">닫기</span>
          </Button>
          <h3 className="tit">{urgencyMessage.title}</h3>
          <p className="txt">{urgencyMessage.content}</p>
        </div>
        <div className="emergency-bg bottom">
          <span className="emergency-bar yellow"/>
          <span className="emergency-bar black"/>
          <span className="emergency-bar yellow"/>
          <span className="emergency-bar black"/>
          <span className="emergency-bar yellow"/>
          <span className="emergency-bar black"/>
          <span className="emergency-bar yellow"/>
          <span className="emergency-bar black"/>
          <span className="emergency-bar yellow"/>
          <span className="emergency-bar black"/>
          <span className="emergency-bar yellow"/>
          <span className="emergency-bar black"/>
          <span className="emergency-bar yellow"/>
          <span className="emergency-bar black"/>
          <span className="emergency-bar yellow"/>
          <span className="emergency-bar black"/>
          <span className="emergency-bar yellow"/>
        </div>
      </UrgencyMessageWrap>
      <ModalBg/>
    </Modal>
  )
}

export default observer(UrgencyMessagePopup)

